import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
            <script src="https://platform.linkedin.com/badges/js/profile.js" async defer type="text/javascript"></script>

    <App />
  </React.StrictMode>
);
